import React, { useContext } from "react";
import { theme } from "../theme";
import Method from "../components/Method";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import Trajectory from "../components/Trajectory";
import Forecast from "../components/Forecast";
import Concerns from "../components/Concerns";
import { General } from "../tools/styles";
import Generic from "../components/Generic";
import calcComplete from "../tools/calcComplete";
import calcForecast from "../tools/calcForecast";
import { WatchContext } from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import BackToDash from "../components/BackToDash";

const Horizontal = () => {

  let { horizontal, setHorizontal } = useContext(WatchContext);

  const handleChange = ({ target }) => {

    let data = handleInputChange(horizontal, target)

    let minCriteria = parseFloat(
      Math.min(data.criteriaLow, data.criteriaHigh)
    );

    let maxCriteria = parseFloat(
      Math.max(data.criteriaLow, data.criteriaHigh)
    );

    data.avgForecast = (data.forecastLow + data.forecastHigh) / 2;

    if (data.currentValue === '' || data.criteriaLow === '' || data.criteriaHigh === '') {
      data.currentConcern = -1
    }
    else if (parseFloat(data.currentValue) < minCriteria) {
      // console.log('current concern!')
      data.currentConcern = 1
    } else {
      // console.log('not current concern!')
      data.currentConcern = 0
    }
    
   if (data.trajectLow === '' || data.trajectHigh === '' || data.forecastYears === ''){ 
    data.futureConcern = -1
  }else if (data.avgForecast < minCriteria || data.avgForecast > maxCriteria) {
      // console.log('future concern!')
      data.futureConcern = 1
    } else {
      // console.log('not future concern!')
      data.futureConcern = 0
    }

    if (data.futureConcern === 1 || data.currentConcern === 1) {
      data.attribConcern = 1
    } else {
      data.attribConcern = 0
    }

    data.forecastLow = calcForecast(data, data.trajectLow)
    data.forecastHigh = calcForecast(data, data.trajectHigh)
    data.complete = calcComplete(data);

    setHorizontal(data);
  };

  let topicItem = horizontal.metrics?.filter(
    (item) => item.metric === horizontal.metric
  )[0] ?? { methods: [] };
  let methods = topicItem.methods.map((item) => item.method) ?? [];


  console.log('horizontal test', horizontal)

  return (
    <General.Background backgroundColor={`${theme.colors.pdeBlue + 40}`}>
      <General.Heading color={theme.colors.pdeBlue}>
        Horizontal Position
      </General.Heading>
      <BackToDash/>
      <Generic
        text={horizontal.metric}
        title='Metric'
      />
      <Method
        currentValue={horizontal.method}
        methodArray={methods}
        handleChange={handleChange}
      />
      <Current
        currentValue={horizontal.currentValue}
        valDesc="Positive (+) values denote waterward movement of edge
            Negative (-) values denote landward movement of edge."
        units={horizontal.units}
        just={horizontal.currentJust}
        handleChange={handleChange}

      />
      <Criteria
        low={horizontal.criteriaLow}
        high={horizontal.criteriaHigh}
        units={horizontal.units}
        type={horizontal.criteriaType}
        just={horizontal.criteriaJust}
        handleChange={handleChange}
      />
      <Trajectory
        low={horizontal.trajectLow}
        high={horizontal.trajectHigh}
        units={horizontal.units}
        just={horizontal.trajectJust}
        handleChange={handleChange}
      />

      <Forecast
        years={horizontal.forecastYears}
        just={horizontal.forecastJust}
        units={horizontal.units}
        forecastLow={horizontal.forecastLow}
        forecastHigh={horizontal.forecastHigh}
        handleChange={handleChange}
      />
      <Generic text={<><strong>Average Forecast</strong>: {horizontal.avgForecast}</>}
      />
      <Concerns
        currentConcern={horizontal.currentConcern}
        futureConcern={horizontal.futureConcern}
        metric={horizontal.metric}
      />
<BackToDash/>
    </General.Background>
  );
};

export default Horizontal;
